
export default {
  name: `AdminForgotPassword`,
  data () {
    return {
      successMsg: null,
      errorMsg: null,
      loading: false
    }
  },
  computed: {
    isDisabled () {
      if (!this.email) {
        return true;
      }
      return false;
    },
    email: {
      get () {
        return this.$store.state.email;
      },
      set (val) {
        this.$store.dispatch('setEmail', val);
      }
    }
  },
  methods: {
    login () {
      this.loading = true;
      this.errorMsg = null;
      this.successMsg = null;

      this.$http.post('/auth/request_password_reset_email', {email: this.email})
      .then((response) => {
        if (response.data.success) {
          this.errorMsg = null;
          this.successMsg = 'Password Reset Email Sent!';
        }
        else {
          this.errorMsg = response.data.error;
        }
      })
      .catch((error) => {
        console.log(error);
        this.errorMsg = error.toString();
      })
      .finally(() => {
        this.loading = false;
      });
    }
  },
  mounted () {
    console.log('adminlogin');
  },
  template: `
    <div class="admin-login-component">
      <div class="innblocks-logo logo32 theme"></div>

      <h3>Forgot Password?</h3>
      
      <p class="success success-block" v-if="successMsg">
          {{successMsg}}
      </p>
    
      <form class="form" v-on:submit.prevent="login" v-else>
        <p class="x-small">Enter your email address to get instructions for resetting your password.</p>
        <div class="row">
          <label class="label">
              <span class="label-text">Email Address</span>
              <span class="input-wrap">
                  <input type="text" v-model="email" />
              </span>
          </label>
        </div>
        <div class="error" v-if="errorMsg">
            {{errorMsg}}
        </div>
        <div class="row">
          <button type="submit" :disabled="isDisabled" class="button">
            <span v-if="loading">...</span>
            <span v-if="!loading">Reset Password</span>
          </button>
        </div>
      </form>
      <div class="small">
        <router-link :to='{name: "login"}'>Login</router-link> &nbsp; &middot; &nbsp;
        <router-link :to='{name: "signup"}'>Sign Up</router-link>
      </div>
    </div>
  `,
};